import React from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import { Icon, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/styles'
import clsx from 'clsx'

const useStyles = makeStyles((theme) => ({
  warningVerification: {
    background: `rgba(247, 72, 114, 0.13)`,
  },
}))

export const WarningVerificationEmail = ({
  pendingEmail,
  onResentPlaceVerificationEmail,
  onCancelPlaceVerificationEmail,
}) => {
  const { formatMessage } = useIntl()
  const classes = useStyles()

  if (!pendingEmail) return null

  return (
    <div
      className={clsx(
        'flex justify-end p-12 border-watermelon border rounded items-center text-watermelon',
        classes.warningVerification,
      )}
    >
      <Typography className="mr-auto">
        <FormattedMessage
          id="profile.contactDetail.warning.email.verification"
          values={{
            pendingEmail,
            b: (text) => <span className="font-bold">{text}</span>,
          }}
        />
      </Typography>
      <div
        onClick={(event) => {
          event.stopPropagation()
          onResentPlaceVerificationEmail()
        }}
        className="cursor-pointer font-bold"
      >
        <Typography>{formatMessage({ id: 'action.resend' })}</Typography>
      </div>
      <div className="mx-8">|</div>
      <Icon
        onClick={(event) => {
          event.stopPropagation()
          onCancelPlaceVerificationEmail()
        }}
        className={clsx('cursor-pointer font-bold')}
      >
        close
      </Icon>
    </div>
  )
}
